module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_horsevalue-f561d5108b3b76794e257f64630dbd99.jpg";